/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
import { method, render } from '../lib';
import { VimeFaketube } from '@vime/core';
import { define } from '../lib';
define('vime-faketube', VimeFaketube);
export default Vue.extend({
    props: {
        language: {},
        autoplay: {},
        controls: {},
        logger: {},
        loop: {},
        muted: {},
        playsinline: {},
    },
    methods: {
        getAdapter: method('getAdapter'),
        dispatchLoadStart: method('dispatchLoadStart'),
        dispatchChange: method('dispatchChange'),
    },
    render: render('vime-faketube', ['vLoadStart']),
});
//# sourceMappingURL=VimeFaketube.js.map